'use client';

import { type FlexProps } from '@ironhack/design-system2/components/flex';
import { Stepper as StepperDs } from '@ironhack/design-system2/components/stepper';
import { type ReactElement } from 'react';

import { ModuleWrapper } from '@/app/components/client/module-wrapper';
import { moduleFormatFragment } from '@/lib/datocms/fragments';
import { type DatoBlock, type DatoModuleFormat } from '@/lib/datocms/types';

type Variant = 'electricBlue' | 'oceanBlue' | 'pink' | 'purple' | 'turquoise';
export type Step = {
  title: string;
  description: string;
};
export type StepperModule = DatoBlock<{
  moduleFormat: [DatoModuleFormat];
  variant: Variant;
  title: string;
  steps: Step[];
}>;

type StepperProps = { data: StepperModule } & FlexProps;
export const Stepper = (props: StepperProps): ReactElement => {
  const { data, ...flexProps } = props;
  const {
    title,
    variant,
    steps,
    moduleFormat: [moduleFormat],
  } = data;

  return (
    <ModuleWrapper
      innerProps={flexProps}
      moduleFormat={moduleFormat}
      outerProps={{
        as: 'section',
        ...flexProps,
      }}
    >
      <StepperDs
        background={moduleFormat.background}
        steps={steps}
        title={title}
        variant={variant}
      />
    </ModuleWrapper>
  );
};

export const stepperFragment = `
  fragment stepperFragment on StepperRecord {
    __typename
    moduleFormat {
      ...moduleFormatFragment
    }
    steps {
      title
      description      
    }
    title
  }

  ${moduleFormatFragment}
`;
